const INTERACTION_CLICK = 'click'
const INTERACTION_SWIPE = 'swipe'
const INTERACTION_KEYPRESS = 'keypress'

export function userInteractionEvent() {
  return {
    INTERACTION_CLICK,
    INTERACTION_SWIPE,
    INTERACTION_KEYPRESS,
  }
}
